import coverage_card_module_default from "./coverage-card.module.js";
import { useTranslation } from "react-i18next";
import { BaseCard, Box, Container, Flex, Stack, Text } from "@myphx-engineering/phx-design-system";
import { constants } from "@myphx-engineering/phx-design-system/framework";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/coverage-card/CoverageCard.tsx
const CoverageCard = ({ patient, planInfo, variant, partnerLogo }) => {
	const { t } = useTranslation("phx-lib");
	const cardType = variant === "benefit" ? t("coverageCard.benefitPlan") : t("coverageCard.smartprice", { tm: constants.unicode.TRADEMARK });
	return /* @__PURE__ */ jsx(Container, {
		className: `${coverage_card_module_default.container} ${coverage_card_module_default[variant]}`,
		type: "inline-size",
		children: /* @__PURE__ */ jsx(BaseCard, {
			"data-testid": "user-card-container",
			withBorder: true,
			p: 0,
			variant: "filled",
			radius: "sm",
			className: coverage_card_module_default[`${variant}-card`],
			children: /* @__PURE__ */ jsxs(Stack, {
				gap: 0,
				children: [/* @__PURE__ */ jsxs(Flex, {
					gap: "sm",
					align: "center",
					justify: "space-between",
					children: [/* @__PURE__ */ jsx(Flex, {
						bg: "primary",
						align: "center",
						className: coverage_card_module_default.logo,
						children: partnerLogo || /* @__PURE__ */ jsx("img", {
							src: "/static/libraries/myphx-lib/logos/prescryptive-logo-white-text.svg",
							alt: t("coverageCard.imageAlt.prescryptivelogo")
						})
					}), /* @__PURE__ */ jsx(Box, {
						p: "0 1rem",
						children: /* @__PURE__ */ jsx(Text, {
							className: coverage_card_module_default.cardType,
							children: cardType
						})
					})]
				}), /* @__PURE__ */ jsxs(Stack, {
					classNames: { root: coverage_card_module_default.contentWrapper },
					flex: "1",
					children: [/* @__PURE__ */ jsxs(Stack, {
						classNames: { root: coverage_card_module_default.nameWrapper },
						"data-testid": "patient-name-container",
						children: [/* @__PURE__ */ jsx(Text, {
							className: coverage_card_module_default.patientName,
							"data-testid": "patient-name",
							children: patient.name
						}), /* @__PURE__ */ jsxs(Flex, {
							gap: "sm",
							children: [/* @__PURE__ */ jsx(Text, {
								className: coverage_card_module_default.fieldLabel,
								children: "ID"
							}), /* @__PURE__ */ jsx(Text, {
								className: coverage_card_module_default.patientId,
								"data-testid": "patient-id",
								children: patient.id
							})]
						})]
					}), /* @__PURE__ */ jsxs(Flex, {
						classNames: { root: coverage_card_module_default.detailsWrapper },
						children: [
							/* @__PURE__ */ jsxs(Stack, {
								classNames: { root: coverage_card_module_default.fieldWrapper },
								"data-testid": "group-container",
								children: [/* @__PURE__ */ jsx(Text, {
									className: coverage_card_module_default.fieldLabel,
									children: "Group"
								}), /* @__PURE__ */ jsx(Text, {
									className: coverage_card_module_default.detailsValue,
									"data-testid": "patient-group",
									children: planInfo.group
								})]
							}),
							/* @__PURE__ */ jsxs(Stack, {
								classNames: { root: coverage_card_module_default.fieldWrapper },
								"data-testid": "bin-container",
								children: [/* @__PURE__ */ jsx(Text, {
									className: coverage_card_module_default.fieldLabel,
									children: "BIN"
								}), /* @__PURE__ */ jsx(Text, {
									className: coverage_card_module_default.detailsValue,
									"data-testid": "patient-bin",
									children: planInfo.bin
								})]
							}),
							/* @__PURE__ */ jsxs(Stack, {
								classNames: { root: coverage_card_module_default.fieldWrapper },
								"data-testid": "pcn-container",
								children: [/* @__PURE__ */ jsx(Text, {
									className: coverage_card_module_default.fieldLabel,
									children: "PCN"
								}), /* @__PURE__ */ jsx(Text, {
									className: coverage_card_module_default.detailsValue,
									"data-testid": "patient-pcn",
									children: planInfo.pcn
								})]
							})
						]
					})]
				})]
			})
		})
	});
};

//#endregion
export { CoverageCard };